<template>
   <div class="container-fluid">
    <div class="row">
      <div class="col-sm-3"></div>

      <div class="col-sm-6">

      <Modal_voorwaarden v-if="showModal" :showModal=showModal @clicked="onChildClick"></Modal_voorwaarden>
      <Modal_order v-if="showModal_order" :showModal=showModal v-bind:result_id="result.id"   @clicked="onChildClick"></Modal_order>
      
        <div v-if="step1">
         <Header></Header>
          <img class="logo_small" alt="Gertrude logo" src="../assets/Gertrude_logo2.png">

              <form @submit.prevent="parseText">
              
                <div class="form-group" style="text-align: left">
                  <label for="titel" class="titel" >Titel</label>
                  <input class="form-control" type="titel" placeholder="" v-model="title" />     
                </div>
                <div class="form-group" style="text-align: left">
                  <label for="pwd">Plak hier je gehele tekst, of een gedeelte, zoals een hoofdstuk. 
                  De lengte moet liggen tussen 1500 en 8000 woorden.</label>
                  <textarea class="form-control" placeholder="" v-model="text" style="height:400px"></textarea>
                </div>
                <div class="form-group form-check" style="text-align: left">
                  <label class="container" >
                  <input type="checkbox" class="question_checkbox"  v-model="checked"  @change="check($event)" >
                   <span class="checkmark"></span> 
                  </label>
                    <span style="margin-left:15px;"> 
                    Ik heb de <a @click="openModal" class="btn btn-info btn-sm" role="button">voorwaarden</a> gelezen en ga er mee akkoord.
                    </span>
                </div>

                <div v-if="system_ready==false" class="alert" >
                    <div class="lds-dual-ring"></div>voorbereiden systeem...
                </div>
                
                <div v-if="system_ready" style="text-align: right">
                  <button ref="send" type="submit" class="btn btn-primary btn-lg" >verstuur</button>
                </div>

              </form>

          <div class="alert_container" style="text-align: center">
              <div v-if="message" class="alert alert-warning alert_1">{{message}}</div>
          </div>

        </div>


        <div v-if="step2">
           <br><br><br><br>
           <div class="pupil">   
            <img class="logo_large" alt="Gertrude logo" src="../assets/Gertrude_logo2.png">
          </div>

           <h2>Gertrude leest...</h2> <br>
           <progress-bar bar-color="#507a44" size="big" :val="pct" :text="pct + '%'"></progress-bar>
         
        </div>


        <div v-if="step3">
        <Header></Header>
          <img class="logo_medium" alt="Gertrude logo" src="../assets/Gertrude_logo2.png">
        </div>

        <div v-if="step3 && result.classification==1 && result.fiction_test==1">
        <br>
          
          <div class="alert alert-success"><h2 class="gefeliciteerd">Gefeliciteerd!</h2>Gertrude heeft je tekst <span class="blue">{{result.title}}</span> vergeleken met andere teksten in de database en vindt dat je tekst lijkt op fictionele teksten die reeds door uitgevers zijn gepubliceerd.
            De overeenkomst van je tekst met door uitgevers gepubliceerde teksten is groter dan met zelf gepubliceerde teksten.
          </div>  

            <div class="alert alert-success">
              Gertrude vindt dat je schrijfstijl het meest lijkt op de stijl van:<br>
              <h4><span class="blue">{{result.author_prediction}}</span></h4>
            </div>
       
        </div>  


      
        <div v-if="step3 && result.classification==1 && result.fiction_test==1 && result.number_extremes == 0">
          <div class="alert alert-secondary">
            Gertrude heeft geen kenmerken gevonden die sterk verschillen met door uitgevers gepubliceerde teksten en constateert een grote overeenkomst.
            Wil je meer weten over de sterke overeenkomst van je tekst met teksten die door uitgevers zijn gepubliceerd, dan kan je het leesrapport van Gertrude bestellen. 
          </div>
        </div>

        <div v-if="step3 && result.classification==1 && result.fiction_test==1 && result.number_extremes == 1">
          <div class="alert alert-secondary">
            Gertrude heeft <span class='blue'>1</span> kenmerk gevonden waarvan de waarde sterk verschilt met het gemiddelde op dit kenmerk bij door uitgevers gepubliceerde teksten.
            Wil je meer weten over de overeenkomsten en verschillen van je tekst met door uitgevers gepubliceerde teksten, dan kan je het leesrapport van Gertrude bestellen. 
          </div>
        </div>

        <div v-if="step3 && result.classification==1 && result.fiction_test==1 && result.number_extremes > 1">
          <div class="alert alert-secondary">
            Wel heeft Gertrude <span class='blue'>{{result.number_extremes }}</span> kenmerken gevonden waarvan de waarden sterk verschillen met het gemiddelde op dit kenmerk bij door uitgevers gepubliceerde teksten.
            Wil je meer weten over de overeenkomsten en verschillen van je tekst met teksten die door uitgevers zijn gepubliceerd, dan kan je het leesrapport van Gertrude bestellen. 
          </div>
        </div>




        <div v-if="step3 && result.classification==0 && result.fiction_test==1">
          <h2 class="alert alert-warning" >Je tekst lijkt het meest op zelf gepubliceerde teksten</h2>
        </div>

       <div v-if="step3 && result.classification==0 && result.fiction_test==1 && result.number_extremes == 0">
          <div class="alert alert-secondary">
            Gertrude heeft je tekst <span class="blue">{{result.title}}</span> vergeleken met andere teksten in de database. 
            Gertrude vindt dat de overeenkomst met zelf gepubliceerde teksten groter is dan met teksten die door uitgevers zijn gepubliceerd.
            Wil je meer weten over de overeenkomsten en verschillen van je tekst met teksten die door uitgevers zijn gepubliceerd, dan kan je het leesrapport van Gertrude bestellen. 
          </div>
        </div>

        <div v-if="step3 && result.classification==0 && result.fiction_test==1 && result.number_extremes == 1">
          <div class="alert alert-secondary">
            Gertrude heeft je tekst <span class="blue">{{result.title}}</span> vergeleken met andere teksten in de database. 
            Gertrude vindt dat de overeenkomst met zelf gepubliceerde teksten groter is dan met teksten die door uitgevers zijn gepubliceerd.<br><br>
            Ook heeft Gertrude <span class='blue'>1</span> kenmerk gevonden waarvan de waarde sterk verschilt met het gemiddelde op dit kenmerk bij door uitgevers gepubliceerde teksten.
            Wil je meer weten over de overeenkomsten en verschillen van je tekst met teksten die door uitgevers zijn gepubliceerd, dan kan je het leesrapport van Gertrude bestellen. 
          </div>
        </div>

        <div v-if="step3 && result.classification==0 && result.fiction_test==1 && result.number_extremes > 1">
          <div class="alert alert-secondary">
            Gertrude heeft je tekst <span class="blue">{{result.title}}</span> vergeleken met andere teksten in de database. 
            Gertrude vindt dat de overeenkomst met zelf gepubliceerde teksten groter is dan met teksten die door uitgevers zijn gepubliceerd.<br><br>
            Ook heeft Gertrude <span class='blue'>{{result.number_extremes }}</span> kenmerken gevonden waarvan de waarden sterk verschillen met het gemiddelde op dit kenmerk bij door uitgevers gepubliceerde teksten.
            Wil je meer weten over de overeenkomsten en verschillen van je tekst met teksten die door uitgevers zijn gepubliceerd, dan kan je het leesrapport van Gertrude bestellen. 
          </div>
        </div>


        
        <div v-if="step3 && result.fiction_test==0">
        <br><br><br>
          <h2 class="alert alert-danger" >Gertrude vindt dat de tekst <span class="blue">{{result.title}}</span> die je hebt verstuurd geen fictie of proza is.</h2>
          <div class="alert alert-danger">Mogelijk heb je een journalistieke tekst verstuurd of een tekst in een andere taal dan het Nederlands.<br>
            Probeer het opnieuw met een fictionele tekst.</div>
        </div>
       


       <div v-if="step3 && result.fiction_test==1">
        <button type="button" @click="openModal_order" class="btn btn-info btn-block" role="button">Bestel het rapport voor &euro; {{price_report}}</button>
        <br><br>
       </div>

         <div v-if="step3" style="text-align:left">
          <button type="button" class="btn btn-info btn-lg " v-on:click="back">opnieuw</button>
        </div>

        <br><br><br><br>
        <div v-if="step3  && result.fiction_test==1">
          <div class='alert alert-secondary disclaimer'>
              Disclaimer: Aan deze classificatie zijn geen rechten te ontlenen. 
              De classificatie gebeurt geheel automatisch en is gebaseerd op machine learning. 
            </div>
        </div>

  

      
      </div>

      <div class="col-sm-3"></div>

    </div>

    </div>
</template>

<script>
import axios from "axios";
import ProgressBar from 'vue-simple-progress';
import Modal_voorwaarden from './Modal.vue';
import Modal_order from './Modal_order.vue';
import Header from './Header.vue';

export default {
  name: 'GertrudeForm',
  props: {
    msg: String
  },
  data() {
    return {
      result: '',
      title:'',
      text:'',
      checked:false,
      step1: true,
      step2: false,
      step3: false,
      message: '',
      pct:0,
      move:'',
      showModal: false,
      showModal_order:false,
      price_report:process.env.VUE_APP_PRICE_REPORT,
      system_ready: false,
    };
  },
   components: {
    ProgressBar,
    Modal_voorwaarden,
    Modal_order,
    Header,
 
  },

  mounted: function() {
    //een keer de api callen om op te porren, gaat slapen op productie
    this.nudgeApi(); 
  },

  methods:{
      parseText(){
        let minimum_number= 1500;
        let maximum_number= 8000;
        let number_words_text= this.wordCount(this.text);
        let title_length = this.title.length;

        if (this.checked==false){
          this.message="Je hebt de checkbox nog niet ingevuld waarmee je aangeeft dat je instemt met de voorwaarden."
          this.changeButtonColor()
        }

        if (number_words_text < minimum_number){
          this.message="Je tekst is te kort. Je hebt "+ number_words_text + " woorden ingevoerd. Je moet minstens "+ minimum_number + " woorden invoeren.";
          this.changeButtonColor()
        }
        if (number_words_text > maximum_number){
            this.message="Je tekst is te lang. Je hebt "+ number_words_text + " woorden ingevoerd. Je kan maximaal "+ maximum_number + " woorden invoeren.";
            this.changeButtonColor()
        }

        if (title_length < 3){
          this.message="Je hebt geen titel ingevoerd, of je titel is korter dan drie tekens.";
          this.changeButtonColor()
        }
         
         if (title_length > 100){
          this.message="Je titel is langer dan 100 tekens. Maak je titel korter.";
          this.changeButtonColor()
        }

        //submit functie callen
        if (number_words_text >= minimum_number && number_words_text < maximum_number && title_length > 2 & title_length < 101 && this.checked==true){
          this.handleSubmit();
          this.moveProgresBar(number_words_text)
        }
      
      },

      wordCount(str) {
        var m = str.match(/[^\s]+/g)
        return m ? m.length : 0;
      },

      nudgeApi(){
          axios.post(process.env.VUE_APP_NUDGE_API, {
        })
        .then(response => {
          this.system_ready=true; // after this first api call response delay is eliminated and the 'send' button can be shown
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
      },

      handleSubmit(){
        //url uit de .env halen:
        axios.post(process.env.VUE_APP_URL_ANALYZE, {
          title: this.title,
          text_for_analyze: this.text,
        })
        .then(response => {
          this.step2=false;
          this.step3=true;
          //console.log(response.data);
          this.result = response.data; //response.body werkt niet!
          this.pct=0;
          clearInterval(this.move);
        })
        .catch(function (error) {
          console.log(error);
        });

        this.step1=false
        this.step2=true
        this.title=''
        this.text=''
        this.message=''
      },

    //back button
    back(){
      this.step2=false;
      this.step3=false;
      this.step1=true;
      this.pct=0;
   
    },

    moveProgresBar(number_words_text){
      //https://github.com/dzwillia/vue-simple-progress
      this.pct=0;
      //console.log(number_words_text);
      let interval=  parseFloat(process.env.VUE_APP_PROGRESSBAR_CONSTANT) + (number_words_text /  parseFloat(process.env.VUE_APP_PROGRESSBAR_DIVISION));
    
      this.move=setInterval( () => {
         this.pct = Math.min(this.pct + 1, 100)
      }, interval)
    },

    openModal() {
      this.showModal = true;
    },
    onChildClick () {
      this.showModal = false;
      this.showModal_order=false;
    },
    openModal_order() {
      this.showModal_order = true;
    },

    changeButtonColor(){
      this.$refs["send"].style.setProperty('background-color', '#ff0000');// knop rood maken als er fouten zijn
    },
    check(){
      this.$refs["send"].style.setProperty('background-color', '#007bff');//knop blauw maken als checkbox is gechecked
      this.message="";
    },

  }
}

//https://reactgo.com/vue-resource-http/



</script>

<style scoped>
.logo_small {
  height: 70px;
  margin-bottom:20px;
}

.logo_medium {
  height: 130px;
  margin-bottom:30px;
}

.logo_large {
  height: 250px;
}

.gefeliciteerd{
  font-size:2.5em;
}
.titel{
  font-size:1.2em;
}
.red{
  color:red;
}

.blue{
  color:blue;
}

.alert_container {
  position:relative;
  width:100%;
  bottom: 3em;
  right: 17%;
}

@media ( max-width: 1500px ) {
  .alert_container {
   
  }

}


.alert_1 {
  width:66%;
  margin: 0 auto;
}

.form-control{
  margin-bottom:30px;
}

.disclaimer{  
  font-size:0.8em;
  color: red;
}

.animation_container{
   margin-left: 50%;
   margin-right:50%;
}

.pupil{
  margin: 0 auto;
  height:350px;
  width: 450px;
  background-image:url("../assets/Gertrude_pupil.png");
  background-repeat: no-repeat;
  background-size: 36% 10%;
  background-position: 170px 145px;
  animation: play 2s infinite;
}

@keyframes play {
    100% { background-position: 125px 145px; }
}


/* checkbox container */
.container {
  display: block;
  cursor: pointer;
  font-size: 1em;
  line-height: 1.8em;
  color: #377DAF;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
 
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 30px;
  width: 30px;
  background-color: #fff;
  border-radius: .2rem;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #b5dfe5;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #17a2b8;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 11px;
  top: 5px;
  width: 8px;
  height: 16px;
  border: solid white;
  border-width: 0 4px 4px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.selected_question_wrapper{
	background-color:#F2F2F3;
	margin-top:50px;
}

.lds-dual-ring {
  display: inline-block;
  width: 36px;
  height: 36px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 36px;
  height: 36px;
  position:relative;
  top:12px;
  right:15px;
  border-radius: 50%;
  border: 4px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
    100%  { transform: rotate(360deg);}
 }

</style>

